import { DemoToggleButtonGroupControl } from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Item from './Item';
import Output from './Output';

function Direction() {
  return (
    <FlexDemo
      initialValues={{
        '--direction': 'column',
        showAxisLabels: true,
      }}
      customGrid={{
        gridTemplateColumns: '1fr',
      }}
      controls={[
        <DemoToggleButtonGroupControl
          inline
          key="--direction"
          id="--direction"
          label="flex-direction"
          options={['row', 'column']}
        />,
      ]}
    >
      {(state) => (
        <Output state={state}>
          <Item>Hello</Item>
          <Item>to</Item>
          <Item>the</Item>
          <Item>world</Item>
        </Output>
      )}
    </FlexDemo>
  );
}

export default Direction;
